/**
 * WhatsApp link helpers. No API calls — just wa.me deep links for now.
 * When Twilio/Meta sandbox is connected, we'll keep using these for outbound
 * manual messages from admins, and swap the inbound path to the webhook.
 */

// wa.me requires no '+' and no spaces in the phone. It accepts international
// digits only. Returns null if the phone is unusable.
export function normalizePhone(raw) {
  if (!raw) return null;
  const digits = String(raw).replace(/[^\d]/g, "");
  if (digits.length < 7) return null;
  return digits;
}

export function whatsappUrl(phone, message = "") {
  const n = normalizePhone(phone);
  if (!n) return null;
  const text = encodeURIComponent(message);
  return `https://wa.me/${n}${text ? `?text=${text}` : ""}`;
}

// Template messages per use-case. Spanish, friendly, Uber-like tone.
export function estadoEs(s) {
  const map = {
    pending: "pendiente",
    confirmed: "confirmado",
    assigned: "asignado",
    on_the_way: "en camino",
    in_transit: "en camino",
    delivered: "entregado",
    cancelled: "cancelado",
  };
  return map[s] || s || "creado";
}

export const waTemplates = {
  orderToClient: (order, companyName) =>
    `Hola${order?.client_name ? ` ${order.client_name}` : ""}! 👋 Te escribo de ${companyName || "Gas2GO"}. ` +
    `Sobre tu pedido #${(order?.order_id || "").slice(-6).toUpperCase()}: ` +
    `estado actual *${estadoEs(order?.status)}*. ¿En qué te podemos ayudar?`,
  clientToCompany: (companyName) =>
    `Hola ${companyName || "Gas2GO"}! 🔥 Quiero hacer un pedido de gas. ` +
    `¿Me ayudas?`,
  clientToCompanyWithOrder: (companyName, lines) =>
    `Hola ${companyName || "Gas2GO"}! 🔥 Quiero pedir:\n${lines}\n¿Me ayudas?`,
};
